export interface SiparisRecord {
  id: number;
  musteriAdi: string;
  telefon: string;
  siparisTuru: string;
  urunAciklama: string;
  detaylar: string;
  siparisTarihi: string;
  teslimTarihi: string;
  kapora: number;
  kalanOdeme: number;
  toplamTutar: number;
  durum: "Alındı" | "Hazırlanıyor" | "Atölyede" | "Teslime Hazır" | "Teslim Edildi" | "İptal";
}

export const siparislerData: SiparisRecord[] = [
  {
    id: 1,
    musteriAdi: "Selin Aydın",
    telefon: "+90 555 678 9012",
    siparisTuru: "Yüzük",
    urunAciklama: "14 Ayar Altın Yüzük",
    detaylar: "Ölçü: 17 | Gram: 3.5g | Taş: 0.10ct Pırlanta",
    siparisTarihi: "2026-04-15",
    teslimTarihi: "2026-05-01",
    kapora: 5000,
    kalanOdeme: 7500,
    toplamTutar: 12500,
    durum: "Teslime Hazır",
  },
  {
    id: 2,
    musteriAdi: "Burak Özdemir",
    telefon: "+90 555 789 0123",
    siparisTuru: "Bilezik",
    urunAciklama: "22 Ayar Bilezik",
    detaylar: "Gram: 20g | Ayar: 22K | Taş: Yok",
    siparisTarihi: "2026-04-10",
    teslimTarihi: "2026-05-02",
    kapora: 15000,
    kalanOdeme: 18000,
    toplamTutar: 33000,
    durum: "Atölyede",
  },
  {
    id: 3,
    musteriAdi: "Zeynep Koç",
    telefon: "+90 555 890 1234",
    siparisTuru: "Kolye",
    urunAciklama: "Taşlı Kolye",
    detaylar: "Ölçü: 45cm | Gram: 5.2g | Taş: 0.50ct Pırlanta",
    siparisTarihi: "2026-04-20",
    teslimTarihi: "2026-05-03",
    kapora: 8000,
    kalanOdeme: 12000,
    toplamTutar: 20000,
    durum: "Hazırlanıyor",
  },
  {
    id: 4,
    musteriAdi: "Emre Yıldız",
    telefon: "+90 555 901 2345",
    siparisTuru: "Alyans",
    urunAciklama: "Platin Alyans",
    detaylar: "Ölçü: 20 | Gram: 8g | Taş: 0.05ct × 2",
    siparisTarihi: "2026-04-25",
    teslimTarihi: "2026-05-05",
    kapora: 5000,
    kalanOdeme: 7000,
    toplamTutar: 12000,
    durum: "Alındı",
  },
  {
    id: 5,
    musteriAdi: "Merve Can",
    telefon: "+90 555 123 4560",
    siparisTuru: "Küpe",
    urunAciklama: "Safir Küpe",
    detaylar: "Gram: 4g | Taş: 0.80ct Safir",
    siparisTarihi: "2026-04-05",
    teslimTarihi: "2026-04-28",
    kapora: 6000,
    kalanOdeme: 9000,
    toplamTutar: 15000,
    durum: "Teslim Edildi",
  },
  {
    id: 6,
    musteriAdi: "Ali Yılmaz",
    telefon: "+90 555 234 5670",
    siparisTuru: "Bileklik",
    urunAciklama: "Gümüş Bileklik",
    detaylar: "Ölçü: 18cm | Gram: 12g | Taş: Zirkon",
    siparisTarihi: "2026-04-18",
    teslimTarihi: "2026-04-30",
    kapora: 1000,
    kalanOdeme: 2000,
    toplamTutar: 3000,
    durum: "İptal",
  },
  {
    id: 7,
    musteriAdi: "Ceren Kılıç",
    telefon: "+90 555 345 6780",
    siparisTuru: "Set",
    urunAciklama: "Gelin Takı Seti",
    detaylar: "Kolye + Küpe + Bilezik | Gram: 45g | Ayar: 22K",
    siparisTarihi: "2026-04-12",
    teslimTarihi: "2026-05-10",
    kapora: 25000,
    kalanOdeme: 55000,
    toplamTutar: 80000,
    durum: "Atölyede",
  },
  {
    id: 8,
    musteriAdi: "Oğuz Arslan",
    telefon: "+90 555 456 7890",
    siparisTuru: "Yüzük",
    urunAciklama: "Pırlanta Tektaş",
    detaylar: "Ölçü: 15 | Gram: 3g | Taş: 0.30ct Pırlanta",
    siparisTarihi: "2026-04-22",
    teslimTarihi: "2026-05-08",
    kapora: 10000,
    kalanOdeme: 15000,
    toplamTutar: 25000,
    durum: "Hazırlanıyor",
  },
];